import env from '@/env';
import { DwsDok } from '@/common';
import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';

export const downloadFileFromDws = async ({ dok, filename }: { dok: DwsDok; filename: string }) => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/download/portal/osv/doc?documentId=${dok.docindexId}&filename=${dok.filename}&originaldocumentId=${dok.docindexId}&filename=${dok.originalfilename}&extension=${dok.extension}&dsdoctype=${dok.dsdoctype}&datum=${dok.date}&cdnUrl=false`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );
  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }
  return {
    res: fetchResponse,
    filename: `${filename}.${dok.extension}`,
  };
};
